import { render, staticRenderFns } from "./apartments-overview.vue?vue&type=template&id=6928ec44&"
import script from "./apartments-overview.ts?vue&type=script&lang=ts&"
export * from "./apartments-overview.ts?vue&type=script&lang=ts&"
import style0 from "./apartments-overview.scss?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports